export default "__VITE_ASSET__DWc$9c8$__"